const reduceItems = <T>(items?: (T | null | undefined)[]): T[] =>
  items?.reduce((prev: T[], curr) => (curr ? prev.concat(curr) : prev), []) ?? [];

export default reduceItems;
